/** Shop days are Japan days (JST, UTC+9, no daylight saving) — design/06, T11-03. */
const JST_OFFSET_MS = 9 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

export type Period = "today" | "7d" | "30d";
export const PERIODS: readonly Period[] = ["today", "7d", "30d"];

/** `YYYY-MM-DD` of the JST day `daysAgo` days before `now`. */
export function jstDate(now: Date, daysAgo = 0): string {
  const shifted = new Date(now.getTime() + JST_OFFSET_MS - daysAgo * DAY_MS);
  return shifted.toISOString().slice(0, 10);
}

/** Inclusive JST day range of a period (`7d` = today and the 6 days before). */
export function periodRange(period: Period, now: Date = new Date()): { from: string; to: string } {
  const to = jstDate(now);
  const back = period === "today" ? 0 : period === "7d" ? 6 : 29;
  return { from: jstDate(now, back), to };
}

/** Start of the period's first JST day as an instant (for `createdAt >= …` comparisons). */
export function periodStart(period: Period, now: Date = new Date()): Date {
  const { from } = periodRange(period, now);
  return new Date(`${from}T00:00:00+09:00`);
}
